export default __webpack_public_path__ + "i18n/translations/translation.91c01fb1.json";